import PropertyValue from '@/components/Typography/PropertyValue';

import BaseLabel from './BaseLabel';
import type { BaseLabelProps } from './BaseLabelTypes';

const LabelWithProperty = (props: BaseLabelProps) => (
  <PropertyValue
    value={<BaseLabel {...props} />}
    isEllipsis={props.isEllipsis}
  />
);

export default LabelWithProperty;
